import EmptyCredits from './EmptyCredits';

export default EmptyCredits;
